import { createTheme } from 'styled-breakpoints';
import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import { breakpoints } from './system/breakpoints';
import { colors } from './system/colors';
import { fontStyle } from './system/fonts';
import { spacing } from './system/spacing';

export const GlobalStyle = createGlobalStyle`
  ${reset}

  body {
    font-family: -apple-system,Roboto,Helvetica Neue,Arial,sans-serif;
  }

  a {
    text-decoration: none;

    &:focus,
    &:hover {
      text-decoration: none;
    }
  }

  input, select, textarea, button {
    font-size: 16px !important;
  }
`;

export const AdminAppGlobalStyle = createGlobalStyle`
  .anticon svg { vertical-align: baseline; }
`;

export const theme = {
  // patterns
  breakpoints: createTheme(breakpoints),
  colors,
  fontStyle,
  spacing,
  // components
};
